import {useId,View} from "vritra";
import css from "./ToDoItem.module.css";


export default function ToDoItem(props){
    const {parent,id=useId("todoitem"),description,done}=props;
    let todoitem=View({parent,id,className:css.todoitem});

    todoitem.innateHTML=`
        <input ref="checkbox" type="checkbox" ${done?"checked":""}/>
        <p 
            class="${css.description}"
            ${done?`style="text-decoration-line:line-through"`:""}
        >${description}</p>
    `;

    todoitem.checkbox.onclick=()=>{
        props.done=!done;
        todoitem=todoitem.substitute(ToDoItem(props));
    }

    return todoitem;
}
